import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";

const shineLines = keyframes`
    0% { background-position: -200px; }
    100% { background-position: 200px; }
`;

const animationDuration = "2.0s";

export const SkeletonWrapper = styled.div`
  width: 100%;
`;

export const Item = styled.div`
  max-width: ${p => p.width};
  height: ${p => p.height};
  background-color: ${p => p.theme.colors.background};
  border-radius: 4px;

  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 200%;
    height: 100%;
    background: linear-gradient(
      90deg,
      rgba(240, 240, 240, 0) 25%,
      rgba(224, 224, 224, 0.5) 50%,
      rgba(240, 240, 240, 0) 75%
    );
    background-size: 200% 100%;
    animation: ${shineLines} ${animationDuration} infinite ease-out;
    z-index: 1;
  }
`;
